(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
   $('.addFilterItem').click(function(e){


     var filterIndex = $(this).data('pos');
     var filterValue = $(this).data('value');

     console.log('new pos' + filterIndex);
     console.log('new val' + filterValue);

     var pos1 = '';
     var pos2 = '';
     var pos3 = '';
     var pos4 = '';
     var url = '';

      $('.addFilterItem').each(function(){

        if ($(this).hasClass('checked')){

          if ($(this).data('pos') == '1'){
            pos1 = $(this).data('value');
          }
          if ($(this).data('pos') == '2'){
            pos2 = $(this).data('value');
          }
          if ($(this).data('pos') == '3'){
            pos3 = $(this).data('value');
          }

         if ($(this).data('pos') == '4'){
            pos4 = $(this).data('value');
          }
        }


        if (filterIndex == "1"){
          pos1 = filterValue;
        }
        if (filterIndex == "2"){
          pos2 = filterValue;
        }
        if (filterIndex == "3"){
          pos3 = filterValue;
        }

         if (filterIndex == "4"){
          pos4 = filterValue;
        }


       url = collectionUrl + "/" + pos1 + "+" + pos2 + "+" + pos3 + "+" + pos4;


      });

       window.location = url;

     e.preventDefault();

   });

  $(document).ready(function() {
      $('[name="filter.p.tag"]').change(function() {
        tags.push($(this).val());




        var tagsString = tags.join('+');



         window.location = collectionUrl + '/' + tagsString;
       });
     });

   class LocalizationForm extends HTMLElement {
     constructor() {
       super();
       this.elements = {
         input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
         button: this.querySelector('button'),
         panel: this.querySelector('.disclosure__list-wrapper'),
       };
       this.elements.button.addEventListener('click', this.openSelector.bind(this));
       this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
       this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

       this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
     }

     hidePanel() {
       this.elements.button.setAttribute('aria-expanded', 'false');
       this.elements.panel.setAttribute('hidden', true);
     }

     onContainerKeyUp(event) {
       if (event.code.toUpperCase() !== 'ESCAPE') return;

       this.hidePanel();
       this.elements.button.focus();
     }

     onItemClick(event) {
       event.preventDefault();
       const form = this.querySelector('form');
       this.elements.input.value = event.currentTarget.dataset.value;
       if (form) form.submit();
     }

     openSelector() {
       this.elements.button.focus();
       this.elements.panel.toggleAttribute('hidden');
       this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
     }

     closeSelector(event) {
       const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
       if (event.relatedTarget === null || shouldClose) {
         this.hidePanel();
       }
     }
   }

    customElements.define('localization-form', LocalizationForm);


  class CurrencyForm extends HTMLElement {
     constructor() {
       super();
       this.elements = {
         input: this.querySelector('input[name="currency"]'),
         button: this.querySelector('button'),
         panel: this.querySelector('.disclosure__list-wrapper'),
       };
       this.elements.button.addEventListener('click', this.openSelector.bind(this));
       this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
       this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

       this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
     }

     hidePanel() {
       this.elements.button.setAttribute('aria-expanded', 'false');
       this.elements.panel.setAttribute('hidden', true);
     }

     onContainerKeyUp(event) {
       if (event.code.toUpperCase() !== 'ESCAPE') return;

       this.hidePanel();
       this.elements.button.focus();
     }

     onItemClick(event) {
       event.preventDefault();
       const form = this.querySelector('form');
       this.elements.input.value = event.currentTarget.dataset.value;
       if (form) form.submit();
     }

     openSelector() {
       this.elements.button.focus();
       this.elements.panel.toggleAttribute('hidden');
       this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
     }

     closeSelector(event) {
       const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
       if (event.relatedTarget === null || shouldClose) {
         this.hidePanel();
       }
     }
   }

    customElements.define('currency-form', CurrencyForm);

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videomp4"] && !Shopify.designMode) return;
  try {
    
          
  $('.unmute').click(function(e){

    var video=document.getElementById("herovideo") ;   
 var video2=document.getElementById("herovideo2") ; 

    
    if ($(this).hasClass('on')){
      $(this).removeClass('on');
      $(this).addClass('off');
        video.muted = true;
       video2.muted = true;
    }else{
      $(this).addClass('on');
      $(this).removeClass('off');
    video.muted = false;
       video2.muted = false;
    }
    e.preventDefault();
  });
  

      
          

  } catch(e) { console.error(e); }
})();
})();
